export enum TipoPeriodoEnum {
  Mes = 1,
  Ano = 2,
  Personalizado = 3,
  Todos = 4
}

export interface DashboardFiltros {
  tipoPeriodo: TipoPeriodoEnum;
  mes?: number;
  ano: number;
  dataInicio?: string;
  dataFim?: string;
  feiraId?: string;
  clienteId?: string;
  listaId?: string;  // Para Call Center
  atendente?: string; // Para Call Center
}

export interface PipelineProjetosResult {
  labels: string[];
  quantidades: number[];
  valoresTotais: number[];
  totalProjetos: number;
}

export interface ReceitaTemporalResult {
  labels: string[];
  valores: number[];
  totalReceita: number;
  mediaReceita: number;
}

export interface MovimentacaoEstoqueResult {
  labels: string[];
  entradas: number[];
  saidas: number[];
  totalEntradas: number;
  totalSaidas: number;
}

export interface StatusOrdensCompraResult {
  labels: string[];
  quantidades: number[];
  totalOrdens: number;
}

export interface ProjetosPorStatusResult {
  labels: string[];
  quantidades: number[];
  valoresTotais: number[];
  totalProjetos: number;
}

export interface ProjetosPorFeiraResult {
  labels: string[];
  quantidades: number[];
  valoresTotais: number[];
  totalProjetos: number;
  totalFeiras: number;
}

export interface ProjetosTemporalResult {
  labels: string[];
  quantidades: number[];
  totalProjetos: number;
  mediaProjetos: number;
}

export interface DashboardGraficosResult {
  pipelineProjetos: PipelineProjetosResult | null;
  receitaTemporal: ReceitaTemporalResult | null;
  movimentacaoEstoque: MovimentacaoEstoqueResult | null;
  statusOrdensCompra: StatusOrdensCompraResult | null;
  projetosPorStatus: ProjetosPorStatusResult | null;
  projetosPorFeira: ProjetosPorFeiraResult | null;
  projetosTemporal: ProjetosTemporalResult | null;
}

export interface ListaContato {
  id: string;
  nomeLista: string;
  dataCadastro: string;
}

export interface ListaDeContatosGeradosResponse {
  listas: ListaContato[];
}

// Interface para próximos eventos (projetos por status)
export interface ProjetoEvento {
  projetoId: string;
  dataInicioFeira: string;
  dataFimFeira: string;
  nomeFeira: string;
}

export interface ProjetosPorStatusResponse {
  projetos: ProjetoEvento[];
}

// Gráficos de Orçamentos - Básicos
export interface OrcamentosPorStatusResult {
  labels: string[];
  quantidades: number[];
  valoresTotais: number[];
  totalOrcamentos: number;
}

export interface OrcamentosPorFeiraResult {
  labels: string[];
  quantidades: number[];
  valoresTotais: number[];
  totalOrcamentos: number;
  totalFeiras: number;
}

export interface OrcamentosTemporalResult {
  labels: string[];
  quantidades: number[];
  valoresTotais: number[];
  totalOrcamentos: number;
  mediaOrcamentos: number;
  totalReceita: number;
}

// Gráficos de Orçamentos - Financeiros
export interface MargemLucroDistribuicaoResult {
  labels: string[];
  quantidades: number[];
  valoresTotais: number[];
  mediaMargemLucro: number;
  medianaMargemLucro: number;
  totalOrcamentos: number;
}

export interface CustoVsReceitaResult {
  labels: string[];
  custos: number[];
  receitas: number[];
  lucrosBrutos: number[];
  margensLucro: number[];
  totalCustos: number;
  totalReceita: number;
  totalLucroBruto: number;
  mediaMargemLucro: number;
}

export interface ComposicaoCustosResult {
  labels: string[];
  totalMaterial: number[];
  totalEquipeXDespesaProducao: number[];
  totalCustoOperacional: number[];
  totalImpostoFaturaIsento: number[];
  totalMargemDeLucro: number[];
  totalComissaoVenda: number[];
  totalStudioArquiteto: number[];
  totalMargemNegociacao: number[];
  totalVenda: number[];
  totalGeral: number;
}

export interface PercentuaisResult {
  labels: string[];
  medias: number[];
  medianas: number[];
  mediaMargemLucro: number;
  mediaComissaoVendas: number;
  mediaStudioArquiteto: number;
  mediaCustoOperacional: number;
  mediaImpostoFaturaIsentoIss: number;
  mediaMargemNegociacao: number;
  medianaMargemLucro: number;
  desvioPadraoMargemLucro: number;
  totalOrcamentos: number;
}

export interface VariacaoResult {
  labels: string[];
  quantidades: number[];
  valoresTotais: number[];
  mediaVariacao: number;
  medianaVariacao: number;
  totalOrcamentos: number;
}

export interface ReceitaMetroQuadradoResult {
  labels: string[];
  receitaPorM2: number[];
  valoresTotais: number[];
  areasTotais: number[];
  mediaReceitaPorM2: number;
  totalReceita: number;
  totalArea: number;
  totalOrcamentos: number;
}

// Gráficos de Orçamentos - Processo
export interface OrcamentosEnvioEmailResult {
  labels: string[];
  quantidadesEnviados: number[];
  quantidadesNaoEnviados: number[];
  taxaEnvio: number[];
  totalEnviados: number;
  totalNaoEnviados: number;
  totalOrcamentos: number;
  taxaEnvioGeral: number;
}

export interface OrcamentosPorEventoResult {
  labels: string[];
  quantidades: number[];
  valoresTotais: number[];
  totalOrcamentos: number;
  totalReceita: number;
}

export interface AprovacaoOrcamentoResult {
  labels: string[];
  quantidades: number[];
  valoresTotais: number[];
  totalOrcamentos: number;
  totalAprovados: number;
  totalReprovados: number;
  totalOrcando: number;
  taxaAprovacao: number;
  taxaReprovacao: number;
}

export interface OrcamentosGraficosResult {
  orcamentosPorStatus: OrcamentosPorStatusResult | null;
  orcamentosPorFeira: OrcamentosPorFeiraResult | null;
  orcamentosTemporal: OrcamentosTemporalResult | null;
  margemLucroDistribuicao: MargemLucroDistribuicaoResult | null;
  custoVsReceita: CustoVsReceitaResult | null;
  composicaoCustos: ComposicaoCustosResult | null;
  percentuais: PercentuaisResult | null;
  variacao: VariacaoResult | null;
  receitaMetroQuadrado: ReceitaMetroQuadradoResult | null;
  orcamentosEnvioEmail: OrcamentosEnvioEmailResult | null;
  orcamentosPorEvento: OrcamentosPorEventoResult | null;
  aprovacaoOrcamento: AprovacaoOrcamentoResult | null;
}

